import Client from '@/app/repository/axios-client';

const resource = '/application/applications';

export default {
  getSocialSupportDetails(applicationId) {
    return Client.get(`${resource}/${applicationId}/social-support/details`);
  },
  changeSocialSupportAmount(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/social-support/change-amount`, payload);
  },
  changeManagementApprovedAmount(applicationId, payload) {
    return Client.put(`${resource}/${applicationId}/social-support/change-management-approved-amount`, payload);
  }
}
